import React from "react";
import "./index.css";
import Typical from "react-typical";
import { NavLink} from "react-router-dom";

const Home = () => {
  return (
    <>
      <section className="home" id="home">
        <div className="max-width">
          <div className="home-content">
            <div className="text-1">Hey, my name is</div>
            <div className="text-2">Sakshat Mali</div>
            <div className="text-3">
              And I'm a{" "}
              <span className="typing">
                <Typical
                  loop={Infinity}
                  wrapper="b"
                  steps={["Programmer", 2000, "Developer", 2000, "Designer", 2000 , "Learner" , 2000]}
                ></Typical>
              </span>
            </div>
            <NavLink to="/about" className="menu-btn">
                About Me
              </NavLink>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
